import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsurancesListComponent } from './insurances-list/insurances-list.component';
import { InsuranceDetailComponent } from './insurance-detail/insurance-detail.component';
import { InsuranceRoutingModule } from './insurances-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { InsuranceCardViewComponent } from './insurances-list/insurance-card-view/insurance-card-view.component';
import { InsuranceListViewComponent } from './insurances-list/insurance-list-view/insurance-list-view.component';
import { PipeModule } from '../../extensions/pipes/pipe.module';

@NgModule({
  declarations: [
    InsurancesListComponent,
    InsuranceDetailComponent,
    InsuranceCardViewComponent,
    InsuranceListViewComponent,
  ],
  imports: [InsuranceRoutingModule, CommonModule, TranslateModule.forChild(), ComponentsModule, PipeModule],
})
export class InsurancesModule {}
